import React from 'react';
import styled from 'styled-components';
import { useRole } from '../../hooks/useRole';

const Banner = styled.div<{ $scoped?: boolean }>`
  background: ${({ $scoped }) => $scoped
    ? 'linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%)'
    : 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)'};
  color: ${({ $scoped }) => $scoped ? '#082f49' : '#78350f'};
  padding: 0.75rem 1.5rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.875rem;
  box-shadow: 0 2px 4px rgba(251, 191, 36, 0.2);
  border-bottom: 1px solid rgba(120, 53, 15, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  
  &::before {
    content: ${({ $scoped }) => $scoped ? "'🛡️'" : "'🔒'"};
    font-size: 1rem;
  }
`;

const ReadOnlyBanner: React.FC = () => {
  const { canEdit, userRole } = useRole();
  const hasScopedActions = ['REFERENCE_DATA_MANAGER', 'COMPLIANCE_OFFICER',
    'MIDDLE_OFFICE_ADMIN', 'OPERATIONS_ANALYST'].includes(userRole || '');

  // Only show banner for non-editing roles
  if (canEdit) {
    return null;
  }

  return (
    <Banner $scoped={hasScopedActions}>
      {hasScopedActions
        ? `You are in role-scoped mode (${userRole}). Authorized workflow actions remain available; unrelated changes stay restricted.`
        : `You are in read-only mode (${userRole}). Contact your administrator to request edit permissions.`}
    </Banner>
  );
};

export default ReadOnlyBanner;
